import Configuration from '@/agilis/util/Configuration'
import jsonLogic from '@/plugins/jsonLogic'
import MetricTitle from '../MetricTitle/MetricTitle.vue'

export default {
  name: 'DashboardTable',
  props: {
    metric: Object,
    items: Array,
    loading: [Boolean, String],
    query: Object,
    context: Object
  },

  components: {
    MetricTitle
  },

  computed: {
    itemsDecorated () {
      const datatable = this.datatable(this.metric) || { columns: {} }
      return Configuration.datatable.decorateItems(datatable, this.items)
    },

    datatable () {
      return metric => {
        const queryDataTable = this.context?.query[this.query.id]?.dataTable
        const metricDataTable = metric.dataTable

        return Configuration.datatable.mergeQueryDataTable(metricDataTable, queryDataTable, { addQueryFields: false })
      }
    },

    result () {
      const logic = this.metric.formula?.jsonLogic
      const items = this.itemsDecorated
      const datatable = this.datatable(this.metric) || { columns: {} }

      const entries = items && (logic ? items.reduce((a, b) => {
        if (jsonLogic.apply(logic, b)) {
          a.push(b)
        }
        return a
      }, []) : items)
      return { columns: datatable.columns, items: entries }
    },

    headers () {
      if (this.result) {
        return Configuration.query.getQueryDatatableHeaders(this.result, this.context)
      }
    },

    itemsPerPageOptions () {
      return [this.metric.itemsPerPage || 5]
    },

    resultItems () {
      return this.result?.items
    }
  },

  methods: {
    renderColumn (colId, item) {
      const colConfig = this.datatable(this.metric).columns[colId]
      return Configuration.datatable.renderColumn(colConfig, item)
    },

    rowClasses (item) {
      if (item.__backgroundColor) {
        // For color classes, see https://vuetifyjs.com/en/styles/colors/#material-colors
        return item.__backgroundColor
      }
      return ''
    }
  }
}
